import styled from "styled-components"

export const AddWrapper = styled.span`
  color: #000;
  display: block;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 8px;
  padding: 16px 24px;
  cursor: pointer;

  svg {
    color: ${(props) => props.theme.colors.primary};
    margin-right: 0.5rem;
    font-size: 1rem;
  }

  span {
    width: fit-content;
    display: flex;
    align-items: center;
    color: #333333;
    font-weight: 400;
  }
`
